import { ProductLicence } from '../../../../api/contract/user-profiles.types';
import { ProfileType } from '../user-service.types';

export const setWalkeMeProfile = (profile: ProfileType | null, productId: number) => {
    if (profile === null) return;

    const products = profile?.productLicenceContainer?.productLicences || [];

    if (products && products.length > 0) {
        const licenceIndex = products.map((value: ProductLicence) => value.id).indexOf(productId);
        const licenceType = products[licenceIndex]?.licenseStatus;

        if (!window.UserDetail) {
            const {
                country,
                user
            } = profile;
            const {
                userProfileId,
                userProfileType,
                regionId,
                isEmailVerified,
                userUniqueIdentifier,
                firstName,
                lastName,
                email
            } = user || {};
            const { code: countryCode } = country || {};
            const locale = country?.cultureCode;
            const identifier = `${countryCode}_${userProfileId}`;

            window.UserDetail = {
                countryCode,
                locale,
                identifier,
                userProfileId,
                userProfileType,
                productId,
                licenceType,
                regionId,
                isEmailVerified,
                guid: userUniqueIdentifier,
                firstName,
                lastName,
                email
            };
        } else {
            window.UserDetail.productId = productId;
            window.UserDetail.licenceType = licenceType;
        }
    }
};
